import {updateLocaleLink} from './helpers';

export { updateLocaleLink };